var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      {
        staticClass: "form-group radio-group form-check form-check-inline",
        attrs: { id: _vm.handle },
      },
      _vm._l(_vm.options, function (o) {
        return _c(
          "label",
          {
            class: _vm.labelClass,
            attrs: { for: "kriterium_" + _vm.criteriaId + "_" + o.code },
          },
          [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.selectedValue,
                  expression: "selectedValue",
                },
              ],
              class: _vm.inputClass,
              attrs: {
                id: "kriterium_" + _vm.criteriaId + "_" + o.code,
                type: "radio",
                autocomplete: "off",
              },
              domProps: { value: o, checked: _vm._q(_vm.selectedValue, o) },
              on: {
                change: [
                  function ($event) {
                    _vm.selectedValue = o
                  },
                  _vm.change,
                ],
              },
            }),
            _vm._v(_vm._s(_vm.getBezeichung(o)) + "\n    "),
          ]
        )
      }),
      0
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }